<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
        <v-toolbar-title aling="center">
          Maestro de Empleados
        </v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
      <v-card flat>
        <PlusMenu :menuItems="menuItems" icon="mdi-account-multiple" />
        <v-card-text>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details
            class="mb-4"></v-text-field>
          <v-data-table :headers="headers" :items="employees" :search="search" class="elevation-1 custom-font"
            :loading="loadEmployees">
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="viewItem(item)">
                mdi-eye
              </v-icon>
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <!-- <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon> -->
            </template>
            <template v-slot:no-data>
              No hay items
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>
    <v-dialog v-model="dialogDelete" max-width="600px">
      <v-card>
        <v-card-title>¿Estás seguro que deseas eliminar este producto?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Volver</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">Eliminar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="crateEditVer" max-width="900px" :key="uniqueKey">
      <viewEmployee :titulo="tituloDialogo" :disabledForm="disabledForm" :dataForm="dataForm"
        :key="dataForm.id ? dataForm.id : 0" :workgroups="workgroups" :newEmployee="newEmployee"
        :costCenters="costCenters" v-on:recibeTickect="createOrUpdateEmployee" />
    </v-dialog>

    <v-dialog v-model="gestRequest" max-width="1000px" :key="keyStock">
      <request v-on="{ closeModal: cancelStock }" />
    </v-dialog>

    <v-dialog v-model="formMassive" max-width="1000px" :key="keyStock">
      <UploadMasiveEmploys title="Subir Empleados Masivo"
        v-on="{ closeModal: cancelStock, confirmData: createMassiveEmployees }" />
    </v-dialog>
    <v-dialog v-model="viewErrorEmployees" max-width="900px" :key="keyStock">
      <TablaDatos :headers="headersErrorEmployees" :datos="errorEmployees" title="Errores en la creación de empleados"
        v-on="{ closeModal: cancelStock }" />
    </v-dialog>
  </div>

</template>
<script>
import axios from "axios";
import api from "../../conf/ruta-base";
import UserProfile from "../../data";
import viewEmployee from "./view.vue";
import PlusMenu from '../../components/plusMenu.vue'
import request from "../../components/request.vue";
import UploadMasiveEmploys from "../../components/UploadMasiveEmploys.vue";
import TablaDatos from "../../components/TablaDatos.vue";
import { getEmployees, updatedCacheEmployees, saveRequest, getEmployeesCount, getCostCenters, updateEmployee, createEmployee } from '../../dataApi'
import router from '../../router'
import { formatRut } from 'rutlib';
import swal from "sweetalert"
import { validateLevelUser, sleep } from '../../proccess/utils';
import { errorCreatedEmployees } from '../../commons/headers';
import store from "../../store";

export default {
  components: {
    viewEmployee,
    PlusMenu, request, UploadMasiveEmploys, TablaDatos
  },
  data: () => ({
    dataForm: {},
    disabledForm: false,
    user: UserProfile.getUserData(),
    search: "",
    tituloDialogo: "Nuevo Producto",
    dialog: false,
    crateEditVer: false,
    dialogDelete: false,
    gestRequest: false,
    products: [],
    headers: [
      { text: "rut", value: "rut" },
      { text: "Nombre", value: "employeeName" },
      //{ text: "Genero", value: "gender" },
      { text: "Cargo", value: "position" },
      { text: "Centro de Costo", value: "costCenter" },
      //{ text: "Costo", value: "costCenter" },
      { text: "Calzado", value: "calzado" },
      { text: "Pantalon", value: "pantalon" },
      { text: "Uniforme", value: "uniforme" },
      //{ text: "Jefatura", value: "managerName" },
      //{ text: "Acciones", value: "actions", sortable: false },
    ],
    employees: [],
    errorEmployees: [],
    editedIndex: -1,
    editedItem: {},
    apiPath: "employs",
    categories: [],
    suppliers: [], uniqueKey: 0, keyStock: 0,
    menuItems: [],
    workgroups: [],
    costCenters: [],
    loadEmployees: false,
    syncTimeoutId: null,
    newEmployee: false,
    formMassive: false,
    viewErrorEmployees: false,
    headersErrorEmployees: errorCreatedEmployees
  }),
  mounted() {
    this.syncNewEmployees();
  },

  methods: {
    async createOrUpdateEmployee(item, bulk = false) {
      if (!bulk) this.errorEmployees = []
      this.crateEditVer = false;
      if (!item) {
        this.close();
        return
      }
      const employee = this.completeAndValidateItem(item)
      if (!employee.id) {
        const newEmployee = await createEmployee(employee, bulk);
        if (newEmployee.success) {
          item.id = newEmployee.id
          this.employees.push(item)
          updatedCacheEmployees(this.employees)
        } else {
          this.errorEmployees.push({
            ...employee,
            flag: false
          })
        }
      } else {
        await updateEmployee(employee.id, employee);
        Object.assign(this.employees[this.editedIndex], employee)
        updatedCacheEmployees(this.employees)
      }
      if (!bulk && this.errorEmployees.length > 0) this.viewErrorEmployees = true
      if (!bulk) this.syncNewEmployees()
    },
    async createMassiveEmployees(data) {
      this.cancelStock()
      for (const employee of data) {
        await this.createOrUpdateEmployee(employee, true)
        await sleep(200)
      }
      console.log('errorEmployees', this.errorEmployees)
      if (this.errorEmployees.length > 0) {
        this.viewErrorEmployees = true
      }
      this.syncNewEmployees()
      store.commit('loading', false)
    },

    agregateComplements(itemProduct) {
      const category = this.categories.find(cat => cat.value === itemProduct.categoryId)
      itemProduct.category = { name: category.text, id: category.value }
      const supplier = this.suppliers.find(sup => sup.value === itemProduct.supplierId)
      itemProduct.supplier = { name: supplier.text, id: supplier.value }
      return itemProduct
    },

    viewDialog() {
      this.crateEditVer = true;
      this.disabledForm = false;
      this.dataForm = {};
    },

    loadWorkGroup() {
      axios.get(api.api + '/workgroup')
        .then(res => {
          res.data.forEach(wg => {
            this.workgroups.push({
              text: wg.name,
              value: wg.id
            })
          })
          console.log("!", this.workgroups)
        })
    },

    async viewRequest() {
      if (this.products.length === 0) {
        axios
          .get(api.api + "/products")
          .then(r => {
            r.data.forEach(product => {
              this.products.push({
                text: `${product.name} - ${product.description}`,
                value: product.id
              });
            })
            this.gestRequest = true;
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.gestRequest = true;
      }

    },

    viewWorkGroups() {
      router.push('/workgroups')
    },

    getColor(estado) {
      if (estado == "No leído") return "default";
      else if (estado == "Resuelto") return "green";
      else if (estado == "Abierto") return "orange";
      else if (estado == "Cerrado") return "red";
    },

    editItem(item) {
      this.uniqueKey++
      this.editedIndex = this.employees.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dataForm = Object.assign({}, item);
      this.tituloDialogo = "Editar parametros de empleados",
        this.crateEditVer = true;
      this.disabledForm = false;
      this.newEmployee = false;
      console.log("Mandamos a editar", this.editedIndex, this.editedItem)
    },

    createItem() {
      this.dataForm = {
        createItem: true
      };
      this.tituloDialogo = "Nuevo Empleado",
        this.crateEditVer = true;
      this.disabledForm = false;
      this.newEmployee = true;
      console.log("Mandamos a crear")
    },

    createMassive() {
      this.formMassive = true;
      console.log("Formulario Masivo")
    },

    deleteItem(item) {
      this.editedIndex = this.tickets.indexOf(item);
      this.editedItem = item;
      this.dialogDelete = true;
    },

    viewItem(item) {
      this.editedIndex = this.employees.indexOf(item);
      this.editedItem = item;
      this.tituloDialogo = "Ver Empleado",
        this.crateEditVer = true;
      this.dataForm = item;
      this.disabledForm = true;
      this.newEmployee = false;
      console.log("se vio");
    },

    deleteItemConfirm() {
      this.tickets.splice(this.editedIndex, 1);
      axios.delete(`${api.api}/products/${this.editedItem.id}`)
      this.editedItem = Object.assign({}, this.defaultItem);
      this.closeDelete();
    },

    close() {
      console.log("cerrando")
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.tickets[this.editedIndex], this.editedItem);
      } else {
        this.tickets.push(this.editedItem);
      }
      this.close();
    },

    completeAndValidateItem(item) {
      const newEmployee = {
        rut: formatRut(item.rut, false),
        active: true,
        adminCostCenter: item.adminCostCenter || false,
        adminWorkGroup: item.adminWorkGroup || false,
        costCenter: item.costCenter,
        dateUniform: item.dateUniform,
        email: item.email,
        firstName: item.firstName || item.names,
        fatherName: item.fatherName,
        motherName: item.motherName || '',
        gender: item.gender,
        mailNotification: item.mailNotification,
        id: item.id,
        managerName: item.managerName,
        managerRut: item.managerRut,
        position: item.position,
        workGroup: item.workGroup,
        talana: item.talana || false,
        sizeMescal: item.calzado || item.sizeMescal.toString(),
        sizePants: item.pantalon || item.sizePants.toString(),
        sizeUniform: item.uniforme || item.sizeUniform.toString()
      }
      return newEmployee
    },

    async saveStock(stock) {
      this.cancelStock();
      saveRequest(stock)
    },

    cancelStock() {
      this.keyStock++;
      this.gestRequest = false;
      this.formMassive = false;
      this.viewErrorEmployees = false;
      this.errorEmployees = [];
    },

    async syncEmployees() {
      axios.get(`${api.api}/employs/sync/talana`).then(response => {
        swal("En proceso...", "Recuerda que este proceso se ejecuta en segundo plano y puede demorar hasta 5 minutos.", "success");
        sessionStorage.setItem("syncEmployees", this.employees.length)
        sessionStorage.setItem("syncEmployeesAtemps", 10)
        this.syncNewEmployees()
      })
    },

    syncNewEmployees() {
      const syncEmployees = sessionStorage.getItem("syncEmployees")
      if (syncEmployees) {
        this.loadEmployees = true;
        this.syncTimeoutId = setTimeout(async () => {
          const totalEmployees = await getEmployeesCount();
          console.log("total", totalEmployees, syncEmployees)
          if (totalEmployees != syncEmployees) {
            this.loadEmployees = false;
          } else {
            sessionStorage.setItem("syncEmployeesAtemps", parseInt(sessionStorage.getItem("syncEmployeesAtemps")) - 1)
            if (sessionStorage.getItem("syncEmployeesAtemps") > 0) {
              this.syncNewEmployees();
            } else {
              this.loadEmployees = false;
              sessionStorage.removeItem("syncEmployees")
              sessionStorage.removeItem("syncEmployeesAtemps")
            }
          }
        }, 60000)
      }
    },

    removeHyphen(text) {
      if (!text) return null
      return text.replace(/-/g, '');
    },
    validateLevelUser
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Empleado" : "Editar Empleado";
    },
    processedItems() {
      return this.tickets.map(product => ({
        ...product,
        stockQuantity: product?.inventory?.quantity ? product?.inventory?.quantity : 0,
      }))
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async created() {
    const employees = (await getEmployees()).employees;
    this.costCenters = await getCostCenters();

    this.employees = employees.map(employee => ({
      ...employee,
      employeeName: employee.firstName + ' ' + employee.fatherName + ' ' + employee.motherName,
      calzado: this.removeHyphen(employee.sizeMescal),
      pantalon: this.removeHyphen(employee.sizePants),
      uniforme: this.removeHyphen(employee.sizeUniform)
    }))

    this.loadWorkGroup()
    this.menuItems = [
      {
        title: 'Sincronizar Empleados',
        icon: 'mdi-rotate-left',
        action: this.syncEmployees,
        roles: `admin,rrhh`
      },
      {
        title: 'Equipos de Trabajo',
        icon: 'mdi-evernote',
        action: this.viewWorkGroups,
        roles: `admin,rrhh`
      },
      {
        title: 'Agregar Empleado',
        icon: 'mdi-account-plus',
        action: this.createItem,
        roles: `admin,rrhh`
      },
      {
        title: 'Carga Masiva de Empleados',
        icon: 'mdi-file-excel',
        action: this.createMassive,
        roles: `admin,rrhh`
      },
    ];
    if (this.validateLevelUser('admin,rrhh', 'Ver')) {
      this.headers.push({
        text: 'Acciones',
        value: 'actions',
        sortable: false
      })
    }
  },

  beforeDestroy() {
    if (this.syncTimeoutId) {
      clearTimeout(this.syncTimeoutId);
    }
  }
};
</script>

<style lang="scss">
.combo-parametros {
  .v-select__selections {
    min-height: 56px !important;
  }
}

.theme--dark.v-chip.default {
  background: #f1f1f1;
  color: rgba(0, 0, 0, 0.87);
}

.v-text-field__details {
  display: none;
}

.custom-font {
  font-family: 'Your Font Family', sans-serif;
  font-size: 16px;
  /* ajusta el tamaño de la fuente según tus necesidades */
  text-transform: uppercase;
}
</style>
